import store from '~/store'
import Swal from "sweetalert2";

export default (to, from, next) => {
    if (
        store.getters['auth/user'].permission_names.indexOf("additional_agreements.show") !== -1
    ) {
        next();
    } else {
        Swal.fire({type: 'warning', title: 'Доступ запрещен!',});
        next({name: 'dashboard'});
    }
}
